import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid2"; // grid v2
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/** Set this if you have a fixed header to subtract */
const VH_OFFSET = 0;

/** Just the height bump — tweak these three to taste */
const HEIGHT_BUMP_MD = 8; // tablets / small laptops
const HEIGHT_BUMP_LG = 18; // laptops / desktops
const HEIGHT_BUMP_XL = 22; // very wide

export default function DesignDetailsSectionMUI() {
	return (
		<Container
			maxWidth={false}
			sx={{
				width: { xs: "95%", lg: "min(1500px, 95%)" },
				px: 0,
				display: "grid",
				gridTemplateRows: { md: "auto auto 1fr", xs: "auto auto auto" },
				gap: 0,

				/** 👇 Only change: increase total section height on desktop */
				height: {
					md: `calc((100dvh + ${HEIGHT_BUMP_MD}dvh) - ${VH_OFFSET}px)`,
					lg: `calc((100dvh + ${HEIGHT_BUMP_LG}dvh) - ${VH_OFFSET}px)`,
					xl: `calc((100dvh + ${HEIGHT_BUMP_XL}dvh) - ${VH_OFFSET}px)`,
					xs: "auto",
				},

				my: { xs: 6, md: 0 },
				py: { xs: 0, md: 3 },
			}}
		>
			{/* Header */}
			<Box sx={{ mb: 1 }}>
				<Typography
					sx={{ letterSpacing: 2, color: "#674934" }}
					fontFamily="'Source Sans Pro', system-ui, sans-serif"
					fontWeight={300}
					fontSize={14}
				>
					PRECISION
				</Typography>

				<Typography
					component="h2"
					sx={{ color: "#674934", m: 0 }}
					fontFamily="'Lora', serif"
					fontWeight={500}
					fontSize={{ xs: 32, sm: 36, md: 44 }}
					lineHeight={1.1}
				>
					Design is in the Details
				</Typography>

				<Typography
					sx={{ color: "#674934", maxWidth: "64ch", mt: 1 }}
					fontFamily="'Source Sans Pro', system-ui, sans-serif"
					fontWeight={400}
					fontSize={{ xs: 16, md: 18 }}
					lineHeight={1.55}
				>
					Every space we create is a reflection of artistry and intention. From
					bespoke finishes to carefully curated textures, we craft environments
					where beauty meets purpose.
				</Typography>

				{/* <Typography sx={{ mt: 1 }}>[Explore&nbsp;Our&nbsp;Designs]</Typography> */}
			</Box>

			{/* Bar */}
			<Box
				sx={{
					height: 52,
					borderRadius: 2,
					display: "grid",
					placeItems: "center",
					background: "#674934",
					my: { xs: 2, md: 2.5 },
				}}
			>
				<Typography
					sx={{ color: "#fff", letterSpacing: 2 }}
					fontFamily="'Source Sans Pro', system-ui, sans-serif"
					fontWeight={600}
					fontSize={18}
				>
					Designs
				</Typography>
			</Box>

			{/* Gallery */}
			<Grid
				container
				spacing={{ xs: 1.5, md: 2 }}
				sx={{
					minHeight: 0,
					height: { md: "100%", xs: "auto" },
				}}
			>
				{/* LEFT: Hero (kept exactly as before) */}
				<Grid
					size={{ xs: 12, md: 5, lg: 7 }}
					sx={{
						minHeight: 0,
						height: { md: "100%", xs: "auto" },
						display: "flex",
					}}
				>
					<Box
						sx={{
							borderRadius: 2,
							boxShadow: "0 6px 24px rgba(0,0,0,.08)",
							overflow: "hidden",
							width: "100%",
							height: { md: "100%", xs: "auto" },
							aspectRatio: { xs: "4/5", md: "auto" },
						}}
					>
						<Box
							component="img"
							src="images/Design 1.png"
							alt="Featured design"
							sx={{
								width: "100%",
								height: "100%",
								objectFit: "cover",
								display: "block",
							}}
						/>
					</Box>
				</Grid>

				{/* RIGHT: Mosaic (kept exactly as before) */}
				<Grid
					size={{ xs: 12, md: 7, lg: 5 }}
					sx={{
						minHeight: 0,
						height: { md: "100%", xs: "auto" },
						display: "grid",
						gridTemplateRows: { md: "1fr 1fr", lg: "2fr 3fr", xs: "auto auto" },
						gap: { xs: 1.5, md: 2 },
					}}
				>
					{/* Row 1: 30/70 */}
					<Box
						sx={{
							display: "grid",
							gridTemplateColumns: "3fr 7fr",
							gap: { xs: 1.5, md: 2 },
							minHeight: 0,
						}}
					>
						<ImageTile src="images/Design 2.png" alt="Top left (30%)" />
						<ImageTile src="images/Design 3.png" alt="Top right (70%)" />
					</Box>

					{/* Row 2: 50/50 with right stacked */}
					<Box
						sx={{
							display: "grid",
							gridTemplateColumns: "1fr 1fr",
							gap: { xs: 1.5, md: 2 },
							minHeight: 0,
						}}
					>
						<ImageTile
							src="images/Design 4.png"
							alt="Bottom left (single tall)"
						/>
						<Box
							sx={{
								display: "grid",
								gridTemplateRows: "1fr 1fr",
								gap: { xs: 1.5, md: 2 },
								minHeight: 0,
							}}
						>
							<ImageTile src="images/Design 5.png" alt="Bottom right - top" />
							<ImageTile
								src="images/Design 6.png"
								alt="Bottom right - bottom"
							/>
						</Box>
					</Box>
				</Grid>
			</Grid>
		</Container>
	);
}

function ImageTile({ src, alt }) {
	return (
		<Box
			sx={{
				width: "100%",
				height: "100%",
				borderRadius: 2,
				boxShadow: "0 6px 24px rgba(0,0,0,.08)",
				overflow: "hidden",
				minHeight: 0,
			}}
		>
			<Box
				component="img"
				src={src}
				alt={alt}
				sx={{
					width: "100%",
					height: "100%",
					objectFit: "cover",
					display: "block",
				}}
			/>
		</Box>
	);
}

// good to go changes
